export namespace API {
  export enum ChatType {
    Message = 'Message',
    Response = 'Response',
    AdsPage = 'AdsPage',
    Legal = 'Legal',
    Error = 'Error',
  }

  export type ChatRequest = {
    message: string
  }

  export type ChatMessage = {
    type: ChatType.Message
    timestamp: number
    data: {
      message: string
    }
  }

  export type ChatResponse = {
    type: ChatType.Response
    timestamp: number
    data: {
      message: string
      ads?: string[]
      total_items_count?: number | null
    }
  }

  export type ChatAdsPage = {
    type: ChatType.AdsPage
    timestamp: number
    data: {
      ads: string[]
    }
  }

  export type ChatLegal = {
    type: ChatType.Legal
    timestamp: number
    data: {
      policy: string
      term_of_service: string
    }
  }

  export type ChatError = {
    type: ChatType.Error
    timestamp: number
    data: {
      message: string
    }
  }

  export type ChatEntry = ChatMessage | ChatResponse | ChatAdsPage | ChatLegal | ChatError
  export type BotChatEntry = ChatResponse | ChatAdsPage | ChatLegal | ChatError

  export type ChatHistoryResponse = {
    data: ChatEntry[]
  }
}

export type TranslationsSchema = {
  readonly firstClientMessage: string
  readonly firstResponseMessage: string
  readonly secondResponseMessage: string

  // UI Text
  readonly placeholder: string
  readonly assistantName: string
  readonly loadMoreProperties: string

  // Loading states
  readonly thinking: string
  readonly loading: string
  readonly loadingProperty: string

  // Error messages
  readonly genericError: string
  readonly adLoadError: string

  // Legal text
  readonly legalPolicy: string
  readonly legalTermOfService: string
}
